import { Post } from "services/apiService";
import {
  FETCH_AUDIT_ORDERS_REQUEST,
  FETCH_AUDIT_ORDERS_SUCCESS,
  FETCH_AUDIT_ORDERS_FAILURE,
} from "../actions/action-type";
import { BASE_URL } from "services/CONSTANTS";

export const fetchAuditData = (params) => async (dispatch) => {
  // Extract API key, limit, offset, and reqBody from the params (payload)
  const { apiKey, limit, offset, reqBody } = params;
  const apiUrl = `${BASE_URL}orders/@fetchorders?apikey=${apiKey}&offset=${offset}&limit=${limit}`;

  // Dispatch the request action to indicate that the fetch process is starting
  dispatch({ type: FETCH_AUDIT_ORDERS_REQUEST });

  // Perform the POST request to the API using the custom Post function
  Post({
    url: apiUrl, // The constructed URL
    params: reqBody, // The request body (payload)
    config: {}, // Default configuration for axios (can be extended if needed)
  })
    .then((response) => {
      // Success - Dispatch the data
      if (response.status === 200) {
        dispatch({
          type: FETCH_AUDIT_ORDERS_SUCCESS,
          payload: response.data, // Ensure 'orders' is the correct key in response data
        });
      } else {
        // Failure - Dispatch error
        dispatch({
          type: FETCH_AUDIT_ORDERS_FAILURE,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      // Handle network or server errors
      dispatch({
        type: FETCH_AUDIT_ORDERS_FAILURE,
        payload: err.response.data,
      });
    });
};
